import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import { Header, Page, PageMain, PageLeft, Button } from 'routes/app/components';

const NotFound = () => (
    <section>
        <Header>
            <h1><FormattedMessage id="page.error.header"/></h1>
        </Header>
        <Page>
            <PageMain title={<FormattedMessage id="page.error.notfound.title" />} full>
                <p><FormattedMessage id="page.error.notfound.body" /></p>
                <div>
                    <Link to="/"><Button><FormattedMessage id="page.error.goHome" /></Button></Link>
                </div>
            </PageMain>
        </Page>
    </section>
);

export default NotFound;